var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Manual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.65 34a5.49 5.49 0 00-5.28-7h-17a5.44 5.44 0 00-5.25-7H26.47a19.55 19.55 0 00-8.38 37.15A23.82 23.82 0 0026.17 59h20.31a5.469 5.469 0 005.39-7H56a5.75 5.75 0 005.65-4.21 5.35 5.35 0 00-.11-2.79h2.58a5.64 5.64 0 005.59-4.29A5.5 5.5 0 0064.65 34zm-.41 7H35v4h20.74a1.61 1.61 0 011.53 1.58A1.38 1.38 0 0155.74 48H35v4h11a1.51 1.51 0 011.48 1.09A1.44 1.44 0 0146 55H25.85a15.51 15.51 0 01.62-31h10.66a1.51 1.51 0 011.47 1.51A1.468 1.468 0 0137.13 27h-11a2 2 0 000 4h33.1a1.512 1.512 0 011.53 1.5 1.53 1.53 0 01-1.39 1.5H35v4h29.19a1.54 1.54 0 011.43.86A1.48 1.48 0 0164.24 41z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Manual.59f466fc.svg";
export { SvgK1Manual as ReactComponent };